import _ from 'lodash'
import { To } from 'react-router-dom'
import { EmptyObject } from 'type-fest'

import { COLLAPSED_Y_DEFAULT } from './constants'
import { CollapsedY, SidebarItem, SidebarItemGroup } from './types'

export const isSidebarItemEmpty = (item: SidebarItem): item is EmptyObject =>
  _.isEmpty(item as EmptyObject)

export const getInitialCollapsedY = (
  items: readonly SidebarItem[],
  pathname: string,
): CollapsedY => {
  const matchesPath = (item: SidebarItem): boolean => {
    if (isSidebarItemEmpty(item) || item.isSelectable === false) {
      return false
    }

    if (item.selectablePaths !== undefined) {
      return item.selectablePaths.some(
        (path: To): boolean => typeof path === 'string' && pathname.includes(path),
      )
    }

    return typeof item.to === 'string' && pathname.includes(item.to)
  }

  const findAncestorGroups = (
    subItems: readonly SidebarItem[],
    ancestorGroups: readonly SidebarItemGroup[],
  ): readonly SidebarItemGroup[] | undefined => {
    for (const item of subItems) {
      if (isSidebarItemEmpty(item)) {
        continue
      } else if (matchesPath(item)) {
        return ancestorGroups
      } else if (item.subItems !== undefined) {
        const nextGroups: readonly SidebarItemGroup[] =
          item.group !== undefined ? [...ancestorGroups, item.group] : ancestorGroups

        const found: readonly SidebarItemGroup[] | undefined = findAncestorGroups(
          item.subItems,
          nextGroups,
        )
        if (found !== undefined) {
          return found
        }
      }
    }

    return undefined
  }

  const matchedGroups: readonly SidebarItemGroup[] | undefined = findAncestorGroups(items, [])
  if (matchedGroups === undefined) {
    return { ...COLLAPSED_Y_DEFAULT }
  }

  return matchedGroups.reduce<CollapsedY>(
    (acc: CollapsedY, group: SidebarItemGroup): CollapsedY => ({ ...acc, [group]: true }),
    { ...COLLAPSED_Y_DEFAULT },
  )
}
